import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import {
  ChatCounterModule,
  FormValidationModule,
  PipesModule,
  SmsWarningModule,
  UtilsModule,
} from '@tablesready/common-ui';
import { AutomationsComponent } from './automations.component';
import { AutomationsRoutingModule } from './automations.routing.module';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';

@NgModule({
  declarations: [AutomationsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormValidationModule,
    NgSelectModule,
    ChatCounterModule,
    AutomationsRoutingModule,
    PipesModule,
    UtilsModule,
    SmsWarningModule,
    NgbAlertModule,
    FrontendDropdownModule,
    NgbTooltipModule,
    FrontendPullRefreshModule,
  ],
})
export class AutomationsModule {}
